import Helper from '../Models/Helper';
import Agent from './Agent';
import Trigger from './Trigger';
import {writable} from 'svelte/store';

const initial = {
	authentication: {active: false, token: ''},
	user: {id: false, name: '', mail: '', initials: ''},
};

let state; try {
	const json = window.localStorage.getItem('session');
	if (json) {
		state = JSON.parse(json);
		state = Object.assign(initial, state);
	}

	if (!Helper.is(state))
		state = initial;
}
catch (error)
	{ state = initial; }

const session = writable(state);

/* Events */

session.subscribe(state => {
	try {
		const json = JSON.stringify(state);
		window.localStorage.setItem('session', json);
	}
	catch (error) { }
});

/* Session */

session.authentication = token => {
	state.authentication.active = !!token;
	state.authentication.token = token;
	session.set(state);
	Trigger.event('authentication', state.authentication);
}

session.user = (id, name, mail, initials) => {
	state.user.id = id;
	state.user.name = name;
	state.user.mail = mail;
	state.user.initials = initials;
	session.set(state);

	Agent.init();
	Trigger.event('user', state.user);
}

session.isAuthenticated = () => {
	return state.authentication.active;
}

session.getToken = () => {
	return state.authentication.token;
}

session.getId = () => {
	return state.user.id;
}

/* Network */

session.router = url => {
	if (url) {
		state.router.url = url;
		session.set(state);
		Trigger.event('router', state.router);
	}

	return state.router ? state.router.url : '';
};

export default session;
